module.exports = __webpack_public_path__ + "static/media/silver-coins-1_1.dc85d038.png";